import { useCallback } from 'react';
import { useInlinePlaceEdit } from '../useInlinePlaceEdit.js';
import { cn } from '../lib/cn.js';
import { PlaceSearch, type SelectedLocation } from './PlaceSearch.js';
import { Button } from './ui.js';

export function EndpointField({ target, location, onSelect, onFocus, resetKey }: {
  target: 'start' | 'destination';
  location?: SelectedLocation;
  onSelect: (location: SelectedLocation) => void;
  onFocus: () => void;
  resetKey: number;
}) {
  const { editing, setEditing, nameRef, editorRef, closeEditor } = useInlinePlaceEdit();
  const label = target === 'start' ? 'Start' : 'Destination';
  const selectReplacement = useCallback((replacement: SelectedLocation) => {
    onSelect(replacement);
    closeEditor();
  }, [closeEditor, onSelect]);

  if (!location) return <PlaceSearch label={label} placeholder={target === 'start' ? 'Search for your starting point' : 'Search for your destination'} onSelect={onSelect} resetKey={resetKey} />;

  return (
    <div className="endpoint-field">
      <div className="endpoint-label">{label}</div>
      <div className="selected-place">
        <span className={cn('marker-dot', target === 'destination' && 'destination-dot')} />
        {editing ? <div ref={editorRef}>
          <PlaceSearch label={`Change ${target}`} placeholder={location.label} initialValue={location.label} onSelect={selectReplacement} inline autoFocus />
        </div> : <button ref={nameRef} type="button" className="endpoint-name" onClick={() => setEditing(true)} aria-label={`Change ${target}: ${location.label}`} title={`Change ${target}`}>
          <strong>{location.label}</strong><small>{target === 'start' ? 'Starting point' : 'Destination'}</small>
        </button>}
        <Button type="button" variant="quiet" onClick={onFocus} aria-label={`Show ${target} on map`}>Show</Button>
      </div>
    </div>
  );
}
